import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Map } from 'immutable';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { ApiGatewayService } from '@http/apiGateway.service';
import { AppState } from 'src/app/state/app-state';

@Injectable()
export class ContractManagementService {
  private appConfiguration$: Observable<any>;
  private gbmAPI: string;
  private gbmComAPI: string;
  private tradingUsaAPI: string;

  constructor(
    private store: Store<AppState>,
    private apiGatewayService: ApiGatewayService,
  ) {
    this.appConfiguration$ = this.store.select('config');

    this.appConfiguration$
      .pipe(
        filter((mapShadowed: any) => Map.isMap(mapShadowed)),
        map((mapShadowed: any) => mapShadowed.toJS()),
        take(1),
      )
      .subscribe((value) => {
        this.gbmAPI = value.api;
        this.gbmComAPI = value.gbmComApi;
        this.tradingUsaAPI = value.tradingUsaApi;
      });
  }

  getContractsBP(): Observable<any> {
    return this.apiGatewayService.get(
      `${this.gbmAPI}api/ContractManagement/GetContractsBP`,
    );
  }

  getContract(contractId: string): Observable<any> {
    return this.apiGatewayService.post(
      `${this.gbmAPI}api/ContractManagement/GetContract`,
      { contractId },
    );
  }

  getContractBuyingPower(
    contractId: string,
    isRealTime?: boolean,
  ): Observable<any> {
    return this.apiGatewayService.post(
      `${this.gbmAPI}api/Operation/GetContractBuyingPower`,
      { request: contractId, isRealTime },
    );
  }

  searchContracts(contractQuery: string): Observable<any> {
    return this.apiGatewayService.post(
      `${this.gbmAPI}api/ContractManagement/SearchContractsByApp`,
      { request: contractQuery },
    );
  }

  getContractOpening(): Observable<any> {
    return this.apiGatewayService.get(`${this.gbmComAPI}v3/opening-status`);
  }

  getAllContractsProperties(contracts: string): Observable<any> {
    return this.apiGatewayService.post(
      `${this.gbmAPI}api/ContractManagement/GetContracts`,
      { request: contracts },
    );
  }

  getAccounts(contractId: string): Observable<any> {
    return this.apiGatewayService.get(
      `${this.gbmComAPI}v2/contracts/${contractId}/accounts`,
    );
  }

  patchAccount(
    contractId: string,
    accountId: string,
    account: any,
  ): Observable<any> {
    return this.apiGatewayService.patch(
      `${this.gbmComAPI}v2/contracts/${contractId}/accounts/${accountId}`,
      account,
    );
  }

  getTradingGlobalAccount(accountId: string): Observable<any> {
    return this.apiGatewayService.get(
      `${this.tradingUsaAPI}v1/accounts/${accountId}`,
    );
  }
}
